// extracted by mini-css-extract-plugin
export var askAiIcon = "_mq-9";
export var container = "_mq-0";
export var groupSeparator = "_mq-a";
export var highlight = "_mq-4";
export var resultIcon = "_mq-5";
export var resultItem = "_mq-7";
export var resultSubtitle = "_mq-3";
export var resultTitle = "_mq-2";
export var resultsList = "_mq-1";
export var searchGroup = "_mq-6";
export var selected = "_mq-8";